export enum TtsPlayerVoice {
  MALE = 'male',
  FEMALE = 'female'
}